<template>
	<component :is="currentPage"></component>
</template>

<script>
	import { mapGetters } from 'vuex'
	import EnterpriseCompany from './EnterpriseCompany'
	import PersonalCompany from './PersonalCompany'

	export default {
		name: 'CompanyManagementEntry',
		components: { EnterpriseCompany, PersonalCompany },
		computed: {
			...mapGetters(['userInfo', 'userType']),
			currentPage() {
				return this.isEnterpriseAccount ? 'EnterpriseCompany' : 'PersonalCompany'
				// return 'EnterpriseCompany'
			},
			// 是否企业账号, 2: 企业账号，4: 个人账号
			isEnterpriseAccount() {
				const accountType = this.userType
				console.log(accountType, typeof accountType)
				return accountType === 2
			}
		}
	}
</script>
